export const routes = [
  {
    path: "/municipio/:id/:uf",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "./components/Get"),
    name: "municipio.get",
  },
];
